<!--导出excel-->
<template>
    <div>
        <el-button size="mini" type="primary" @click="exportExcel()">导出excel</el-button>
        <form name="downForm" method="get"></form>
    </div>
</template>

<script>
    import host from 'Host';
    export default {
        name: 'exportExcel',
        props: ['params','target','action','field','fieldname','filename','method'],
        data() {
            return {

            }
        },
        created() {
        },
        mounted() {

        },
        methods: {
            exportExcel() {
                this.params.token = this.$store.getters.token;
                let params = {
                    params: this.params,
                    target: this.target,
                    action: this.action,
                    field: this.field,
                    fieldName: this.fieldname,
                    filename: this.filename,
                    method: this.method
                }
                this.$api.post(this.$apiUrl.exportV3,params,(res)=>{
                    if(res.data) {
                        window.location.href = host.domain + res.data;
                    }
                },(res)=>{
                    this.$message.warning(res.msg);
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// exportExcel2.vue?3c06748a